import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { Post, Users } from "../../types/Types";

type UpdatePostDto = Partial<Post>;

export const useCreatePost = (
  options?: UseMutationOptions<
  Post,
    unknown,
    Post | UpdatePostDto | FormData,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: Partial<Post> | FormData) => {
      const isFormData = data instanceof FormData;
      
      // Determine if it's an update or create operation
      const hasId = isFormData ? data.get('id') ?? null : (data as Partial<Post>)?.id ?? null;
      
      // Set headers for FormData
      const config = isFormData 
        ? { headers: { 'Content-Type': 'multipart/form-data' } }
        : {};

      if (hasId) {
        return axiosInstance
          .put(getAPIURL(`/Post/Update`), data, config)
          .then((res) => res.data);
      } else {
        return axiosInstance
          .post(getAPIURL("/Post/Create"), data, config)
          .then((res) => res.data);
      }
    },
  });
};
